import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { INFINITE_CACHE_AND_STALE_TIME } from 'constants/index';
import { useQuery } from 'react-query';
import toastr from 'react-hot-toast';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { fetchWrapper } from 'utils/fetchWrapper';
import type {
  PluginConnectionsStatusTypes,
  PluginConnectionsStatusTypesResponse,
} from 'types/PluginConnectionsStatusTypes';
import React from 'react';

const getPluginConnectionStatusType = () => {
  const url = generateURL(SPARK_RESOURCE_TYPES.PLUGIN_CONNECTIONS_STATUS_TYPES);

  return fetchWrapper<PluginConnectionsStatusTypesResponse>({
    url: url,
    method: 'GET',
  });
};

export const usePluginConnectionStatusTypes = () => {
  const query = useQuery(
    ['pluginConnectionStatusType'],
    getPluginConnectionStatusType,
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(
            `failed to Fetch Plugin connection status type: ${error.message}`
          );
        }
      },
      ...INFINITE_CACHE_AND_STALE_TIME,
    }
  );
  const { data } = query;
  const { data: pluginConnectionStatusTypes } = data || {};

  const pluginConnectionStatusTypeIDMap = React.useMemo(() => {
    return pluginConnectionStatusTypes?.reduce<
      Record<string, PluginConnectionsStatusTypes>
    >((acc, curr) => {
      return { ...acc, [curr.id]: curr };
    }, {});
  }, [pluginConnectionStatusTypes]);

  return {
    ...query,
    pluginConnectionStatusTypeIDMap,
  };
};
